/** Lowercase storage; signup may send mixed case — normalize before check. */
export const USERNAME_RE = /^[a-z0-9]+$/;
export const USERNAME_MIN_LEN = 5;
export const USERNAME_MAX_LEN = 32;
